import { useContext } from "react";
import { dimension } from "./DrawingContainer";
import { DrawingContainerContext } from ".";
import { assetsUrl } from "../../../constants";

const ImageSelect = () => {
  const targetWidth = dimension.width;
  const targetHeight = dimension.height;
  // const targetHeight = dimension.height - 120;
  const { setImageUrl } = useContext(DrawingContainerContext);
  const handleImageResizeFromUrl = (url: string) => {
    const img = new Image();
    img.crossOrigin = "anonymous"; 
    img.src = url;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      if (ctx) {
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const resizedUrl = URL.createObjectURL(blob);
              setImageUrl(resizedUrl); // Assuming setResizedImage is a state setter
            }
          },
          "image/jpeg",
          0.8 // Quality (0-1)
        );
      }
    };

    img.onerror = () => {
      console.error("Failed to load image from URL.");
    };
  };
  const handleSelectImage = (selected: string) => {
    const url = `${assetsUrl}/activity/${selected}.jpg`;
    handleImageResizeFromUrl(url);
  };
  return (
    <div>
      <map name="imagemap">
        <div id="brain">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="250.5,87,28"
            onClick={() => {
              handleSelectImage("brain");
            }}
          />
        </div>
        <div id="heart">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="326,120,28"
            onClick={() => {
              handleSelectImage("heart");
            }}
          />
        </div>
        <div id="stomach">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="374,182,24"
            onClick={() => {
              handleSelectImage("stomach");
            }}
          />
        </div>
        <div id="pancreas">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="385,255,27"
            onClick={() => {
              handleSelectImage("pancreas");
            }}
          />
        </div>
        <div id="bladder">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="377,329,27"
            onClick={() => {
              handleSelectImage("bladder");
            }}
          />
        </div>
        <div id="male">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="333,401,27"
            onClick={() => {
              handleSelectImage("male");
            }}
          />
        </div>
        <div id="intestine">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="250,435,28"
            onClick={() => {
              handleSelectImage("intestine");
            }}
          />
        </div>
        <div id="female">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="167,399,27"
            onClick={() => {
              handleSelectImage("female");
            }}
          />
        </div>
        <div id="kidney">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="127,329,27"
            onClick={() => {
              handleSelectImage("kidney");
            }}
          />
        </div>
        <div id="gallbladder">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="114,255,27"
            onClick={() => {
              handleSelectImage("gallbladder");
            }}
          />
        </div>
        <div id="liver">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="127,181,27"
            onClick={() => {
              handleSelectImage("liver");
            }}
          />
        </div>
        <div id="lungs">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="173,118,26"
            onClick={() => {
              handleSelectImage("lungs");
            }}
          />
        </div>
        <div id="skin">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="310,31,26"
            onClick={() => {
              handleSelectImage("skin");
            }}
          />
        </div>
        <div id="eye">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="410,60,25"
            onClick={() => {
              handleSelectImage("eye");
            }}
          />
        </div>
        <div id="teeth">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="472,111,27"
            onClick={() => {
              handleSelectImage("teeth");
            }}
          />
        </div>
        <div id="nose">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="190,34,25"
            onClick={() => {
              handleSelectImage("nose");
            }}
          />
        </div>
        <div id="tongue">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="82,64,25"
            onClick={() => {
              handleSelectImage("tongue");
            }}
          />
        </div>
        <div id="ear">
          {" "}
          <area
            className="cursor-pointer"
            shape="circle"
            coords="28,151,25"
            onClick={() => {
              handleSelectImage("ear");
            }}
          />
        </div>
      </map>

      <div id="fullbody">
        {" "}
        <img
          width={"500px"}
          height={"467px"}
          src={`${assetsUrl}/activity/fullbody.jpg`}
          useMap="#imagemap"
        />
      </div>
    </div>
  );
};

export default ImageSelect;
